<template>
  <div
    class="-mx-12 p-12 flex flex-col flex-wrap justify-between border-t border-purple-ap-t03"
  >
    <h2 class="font-semibold text-purple-ap-100">
      Childcare Experience by Age Group
    </h2>

    <div class="flex flex-col lg:flex-row justify-between mt-5">
      <div class="text-center">
        <p>
          <strong>Under 1</strong>
        </p>
        <p>
          {{
            aupair.childcareExperienceUnder1 > 0
              ? `${aupair.childcareExperienceUnder1} Hours`
              : `No Experience`
          }}
        </p>
      </div>
      <div class="text-center">
        <p>
          <strong>Under 2</strong>
        </p>
        <p>
          {{
            aupair.childcareExperienceUpTo2 > 0
              ? `${aupair.childcareExperienceUpTo2} Hours`
              : `No Experience`
          }}
        </p>
      </div>
      <div class="text-center">
        <p>
          <strong>Up to 5</strong>
        </p>
        <p>
          {{
            aupair.childcareExperienceUpTo5 > 0
              ? `${aupair.childcareExperienceUpTo5} Hours`
              : `No Experience`
          }}
        </p>
      </div>
      <div class="text-center">
        <p>
          <strong>Up to 10</strong>
        </p>
        <p>
          {{
            aupair.childcareExperienceUpTo10 > 0
              ? `${aupair.childcareExperienceUpTo10} Hours`
              : `No Experience`
          }}
        </p>
      </div>
      <div class="text-center">
        <p>
          <strong>Over 10</strong>
        </p>
        <p>
          {{
            aupair.childcareExperienceOver10 > 0
              ? `${aupair.childcareExperienceOver10} Hours`
              : `No Experience`
          }}
        </p>
      </div>
    </div>
    <div class="mt-5">
      <p>{{ aupair.childcareSummary }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FullChildCareExperience",
  props: {
    aupair: Object,
  },
};
</script>
